/* eslint-disable no-console */
import { LoggerService } from './LoggerService'

export const LoggerServiceConsole: LoggerService = {
  logError: (e) => console.error(e),
}
